import Vue from "vue";
import Vuex from "vuex";
import ModalPlugin from "./components/ModalPlugin";

import api from './service/api'
import './pollyfills'
import moment from 'moment'
import * as Sentry from '@sentry/browser'
import LogRocket from 'logrocket';

Vue.use(Vuex);
Vue.use(ModalPlugin);

var notifier = new Vue();

var jwtDecode = require("jwt-decode");

var checker;

function parseAuthToken(state, token) {
  if (token) {
    try {
      var decoded = jwtDecode(token)

      state.expOffset = decoded.expOffset 
      // state.expiry = moment(decoded.exp * 1000) <-- Old, session instantly expires if users change their clock forwards
      // state.expiry = moment().add(state.expOffset, 'ms') <-- V1 fix, session never expires on refresh/new tab even tho token has expired
      state.expiry = moment(state.tokenStart).add(state.expOffset, 'ms') // <-- V2 fix, session expires on offSet from when token was first acquired 
      state.autoLogout =  state.expiry.clone().add(14, 'minutes')
      console.log("tokenstartat:" + moment(state.tokenStart).format())
      console.log("tokenexpires:" + moment(state.expiry).format())
      console.log("autologoutat:" + moment(state.autoLogout).format())
      
      state.username = decoded.sub
      state.paymentType = decoded.paymentType
      state.vatPayer = decoded.vatPayer
      state.tcsVersion = decoded.tcsVersion
      state.interuptMessageAck = decoded.interuptMessageAck
      state.refRequired = decoded.refRequired || false
      state.refLabel = decoded.refLabel || null
      state.appRefLabel = decoded.appRefLabel || null
      state.hasApplicants = decoded.hasApplicants
      state.inviteApplicants = decoded.inviteApplicants
      state.hasReferrals = decoded.hasReferrals
      state.isIndividual = decoded.isIndividual
      state.isApplicant = decoded.isApplicant
      state.applicantPays = decoded.applicantPays
      state.isImpersonating = decoded.isAvatar
      state.allowTypesRaw = decoded.allowedTypes ? JSON.parse(decoded.allowedTypes) : null
      state.ownerLogo = decoded.ownerLogo || null
      state.partnerLogo = decoded.partnerLogo || null
      state.admin = decoded.authorities.some(auth => auth.authority == 'ROLE_ADMIN')
      state.hasCountryAccess = decoded.hasCountryAccess || false
      state.hasAnalyticsAccess = decoded.hasAnalyticsAccess || false
      state.hasReportsAccess = decoded.hasReportsAccess || false
      state.startHome = decoded.startHome || false
      state.hasDiscount = decoded.hasDiscount || false
      state.currency = decoded.currency || null
      state.sharingDisabled = decoded.sharingDisabled || null
      state.accreditationEnabled = decoded.accreditationEnabled || null
      state.showDeleted = decoded.showDeleted || null
      state.idCount = decoded.idCount || null
      
      Sentry.configureScope((scope) => {
        scope.setUser({"username": decoded.sub});
      })
      LogRocket.identify(state.username);
      if (
        state.paymentType.startsWith("INSTITUTE") ||
        state.paymentType.startsWith("TOKEN") ||
        state.paymentType == "CARD"
      ) {
        creditChecker(state);
      }
    } catch (error) {
      alert(
        "Authentication failed, could not read API token. Please contact Qualification Check support.",
        "Error"
      );
      console.log(error);
      logout(state);
    }
  }
}

function updateMeta(state) {
  api
    .getVerificationMetaData(["AWAITING_CONSENT", "NOT_FOUND", "REJECTED"])
    .then((response) => {
      if (response.data.resultCounts) {
        state.verificationsIncomplete = 0;
        state.verificationsActionRequired = 0;
        response.data.resultCounts.forEach((result) => {
          if (result.key === "AWAITING_CONSENT") {
            state.verificationsIncomplete = result.value;
          } else {
            state.verificationsActionRequired += result.value;
          }
        });
      }
      if (response.data.pendingCount) {
        state.outstandingPendings = response.data.pendingCount;
      }
    });
  if (state.isIndividual) {
    api
      .getApplicationHistory({
        status: ["OPEN"],
        page: 0,
        size: 500,
      })
      .then((response) => {
        state.openApplications = response.data.totalSize;
      })
      .catch((error) => {
        console.log(error);
      });
  }
}

function refreshChecker(state) {
  clearTimeout(checker);
  checker = setTimeout(
    () => {
      if (moment().isBefore(moment(store.state.expiry))) {
        creditChecker(state);
      }
    },
    30000,
    state
  );
}

function creditChecker(state) {
  api
    .getCreditInfo(true)
    .then((response) => {
      state.currentCredit = response.data.credit;
      refreshChecker(state);
    })
    .catch((error) => {
      state.currentCredit = null;
      console.error("Failed to update current credit.");
      console.error(error);
      clearTimeout(checker);
    });
}

function logout(state) {
    try {
      notifier.$modal.close()
    } catch (error) {
      console.log(error)
      // But otherwise who cares
    }
    state.token = null
    state.refresh = null
    state.admin = false
    state.publicToken = null
    state.expiry = null
    state.autoLogout = null
    state.username = null
    state.currentCredit = null
    state.paymentType = null
    state.vatPayer = null
    state.refRequired = false
    state.refLabel = null
    state.appRefLabel = null
    state.tcsVersion = null
    state.hasApplicants = false
    state.inviteApplicants = false
    state.hasReferrals = false
    state.openApplications = 0
    state.isIndividual = false
    state.isApplicant = false
    state.applicantPays = false
    state.isImpersonating = false
    state.allowTypesRaw = null
    state.interuptMessageAck = null
    state.applicationInProgress = null
    state.verificationsInProgress = 0
    state.verificationsIncomplete = 0
    state.verificationsActionRequired = 0
    state.outstandingPendings = 0
    state.unseenInvoices = 0
    state.ownerLogo = null
    state.partnerLogo = null
    state.pendingInstitutesArray = null,
    state.loginDialogBox = false,
    state.checkPending = true,
    state.dismissed = []
    state.accreditationEnabled = false
    localStorage.removeItem("token")
    localStorage.removeItem("tokenStart")
    localStorage.removeItem("refresh")
    clearTimeout(checker)
}

const store = new Vuex.Store({
  state: {
    isQCAS: false,
    token: null,
    tokenStart: null,
    refresh: null,
    admin: false,
    publicToken: null,
    expiry: null,
    autoLogout: null,
    username: null,
    currentCredit: null,
    paymentType: null,
    vatPayer: null,
    refRequired: false,
    refLabel: null,
    appRefLabel: null,
    tcsVersion: 0,
    hasApplicants: false,
    inviteApplicants: false,
    hasReferrals: false,
    openApplications: 0,
    isIndividual: false,
    isApplicant: false,
    applicantPays: false,
    isImpersonating: false,
    allowTypesRaw: null,
    interuptMessageAck: null,
    applicationInProgress: null,
    verificationsInProgress: 0,
    verificationsActionRequired: 0,
    verificationsIncomplete: 0,
    outstandingPendings: 0,
    unseenInvoices: 0,
    ownerLogo: null,
    partnerLogo: null,
    historyFilters: {
      query: "",
      requestedBy: null,
      customerReference: null,
      results: [],
      dateRange: [],
    },
    redirectPage: null,
    initInstitute: null,
    selectionWarning: false,
    dismissed: [],
    qcmc: null,
    loadMapName: "Annual Average Verification Times",
    mapData: [],
    fraudulentCountryMapData: [],
    turnaroundCountryMapData: [],
    fiftyPercentMapData: [],
    instituteNumbersMapData: [],
    mapSelectedCountry: null,
    minYear: null,
    loadingChartData: false,
    loginDialogBox: false,
    pendingInstitutesArray: null,
    checkPending: true,
    reloadApplicantHistoryTable: false,
    applicantCheckboxArchive: false,
    applicantSelectedRows: [],
    volumeChartName: "",
    countryStatsChartName: "",
    revenueGraphChartName: "",
    verificationsChartName: "",
    downloadVolumeSheet: false,
    downloadCountrySheet: false,
    downloadRevenueSheet: false,
    downloadVerificationsSheet: false,
    qcAdmin: false,
    savedVerificationData: {
      dob: "",
      firstName: "",
      lastName: "",
      instituteId: ""
    },
    previousVerificationData: null,
  },
  getters: {
    preSalePrice: (state) => (newPrice) => {
      switch(newPrice) {
        case 40.5: return 45;
        case 36: return 40;
        case 18: return 20;
        case 9: return 10;
        case 8.55: return 9.5;
        case 23.4: return 26;
        case 44.1: return 49;
        default: return 100;

      }
    },
    token: (state) => state.token,
    usesTokens: (state) => {
      return (
        state.paymentType.startsWith("INSTITUTE") ||
        state.paymentType.startsWith("TOKEN")
      );
    },
    username: (state) => state.username,
    historyFilters: (state) => state.historyFilters,
    refLabel: (state) => state.refLabel || "Your Reference",
    appRefLabel: (state) => state.appRefLabel || "Reference",
    allowedTypes: (state) => {
      if (state.allowTypesRaw) {
        return state.allowTypesRaw;
      } else if (state.username.includes("qualificationcheck.com")) {
        return ["edu", "emp", "pli", "pce", "idc", "hsc"];
      } else {
        if (state.isIndividual && !state.isApplicant) {
          return ["edu", "pli", "pce", "hsc"]; // removed 'emp' as disabling employment checks by default, 'idc' not enabled by default
        } else if (state.isIndividual && state.isApplicant) {
          return ["edu", "pli", "pce", "hsc"]; // removed 'emp' as disabling employment checks by default, 'idc' not enabled by default
        } else {
          return ["edu", "emp", "pli", "pce", "hsc"]; 
        }
      }
    },
    allowed: (state, getters) => (type) => {
      return getters.allowedTypes.includes(type);
    },
    isNonApplicantIndividual: (state) => {
      return state.isIndividual && !state.isApplicant;
    },
    getMapName: (state) => {
      return state.loadMapName;
    },
    getSelectedCountry: (state) => {
      return state.mapSelectedCountry
    },
    getApplicantCheckboxArchive: (state) => {
      return state.applicantCheckboxArchive
    },
    getReloadApplicantHistoryTable: (state) => {
      return state.reloadApplicantHistoryTable
    },
    isIndividual: state => {
      return state.isIndividual
    },
    getDownloadRevenueSheet: state => {
      return state.downloadRevenueSheet
    },
    getDownloadVolumeSheet: state => {
      return state.downloadVolumeSheet
    },
    getDownloadCountrySheet: state => {
      return state.downloadCountrySheet
    },
    getDownloadVerificationsSheet: state => {
      return state.downloadVerificationsSheet
    },
    getVerificationsChartName: state => {
      return state.verificationsChartName
    },
    getVolumeChartName: state => {
      return state.volumeChartName
    },
    getCountryStatsChartName: state => {
      return state.countryStatsChartName
    },
    getRevenueGraphChartName: state => {
      return state.revenueGraphChartName
    },
  },
  mutations: {
    setMapData: (state, payload) => {
      if (payload.startsWith("Annual Verification")) {
        state.loadMapName = "Annual Average Verification Times (Days)";
      } else if (payload.startsWith("Fraudulent")) {
        state.loadMapName = "Fraudulent Verifications (%)";
      } else if (payload.startsWith("Current Verification")) {
        state.loadMapName = "Current Verification Times (Days)";
      } else if (payload.startsWith("Current Number of Institutions")) {
        state.loadMapName = "Current Number of Institutions";
      }
    },
    setBranding: (state, payload) => {
      if (payload.startsWith("qcas")) {
        state.isQCAS = true;
      } else {
        state.isQCAS = false;
      }
    },
    initState: (state) => {
      state.publicToken = null
      if(localStorage.getItem("token")) {
        state.token = localStorage.getItem("token")
        if(localStorage.getItem("tokenStart")) {
          state.tokenStart = parseInt(localStorage.getItem("tokenStart"))
        } else {
          logout(state)
        }
        parseAuthToken(state, state.token)
      }
      if (localStorage.getItem("refresh")) {
        state.refresh = localStorage.getItem("refresh");
      }
      if (localStorage.getItem("dismissed")) {
        state.dismissed = JSON.parse(localStorage.getItem("dismissed"));
      }
    },
    setPublicToken: (state, payload) => {
      logout(state);
      state.publicToken = payload;
    },
    updateLogin: (state, payload) => {
      state.token = payload.token
      state.tokenStart = moment().valueOf()
      state.refresh = payload.refresh
      localStorage.setItem("token", state.token)
      localStorage.setItem("tokenStart", state.tokenStart)
      localStorage.setItem("refresh", state.refresh)
      state.publicToken = null
      parseAuthToken(state, state.token)
      updateMeta(state)
    },
    logout: (state, payload) => {
      logout(state);
    },
    updateMeta: (state, payload) => {
      updateMeta(state);
    },
    setTcsVersion: (state, payload) => {
      state.tcsVersion = payload;
    },
    addUnseenInvoice: (state, payload) => {
      state.unseenInvoices++;
    },
    resetUnseenInvoices: (state, payload) => {
      state.unseenInvoices = 0;
    },
    setApplicationInProgress: (state, payload) => {
      state.applicationInProgress = payload;
    },
    setVerificationsInProgress: (state, payload) => {
      state.verificationsInProgress = payload;
    },
    setOutstandingPendings: (state, payload) => {
      state.outstandingPendings = payload;
    },
    setOwnerLogo: (state, payload) => {
      state.ownerLogo = payload;
    },
    setPartnerLogo: (state, payload) => {
      state.partnerLogo = payload;
    },
    setHistoryFilters: (state, payload) => {
      if (payload.query) {
        state.historyFilters.query = payload.query;
      }
      if (payload.requestedBy) {
        state.historyFilters.requestedBy = payload.requestedBy;
      }
      if (payload.customerReference) {
        state.historyFilters.customerReference = payload.customerReference;
      }
      if (payload.results) {
        state.historyFilters.results = payload.results;
      }
      if (payload.dateRange) {
        state.historyFilters.dateRange = payload.dateRange;
      }
    },
    clearHistoryFilters: (state, payload) => {
      state.historyFilters = {
        query: "",
        requestedBy: null,
        customerReference: null,
        results: [],
        dateRange: [],
      };
    },
    setOpenApplications: (state, payload) => {
      state.openApplications = payload;
    },
    setRedirectPage: (state, payload) => {
      state.redirectPage = payload;
    },
    setInitInstitute: (state, payload) => {
      state.initInstitute = payload;
    },
    setSelectionWarning: (state, payload) => {
      state.selectionWarning = payload;
    },
    addCurrentCredit: (state, payload) => {
      state.currentCredit = state.currentCredit + payload;
    },
    closeApplication: (state, payload) => {
      state.openApplications--;
    },
    dismiss: (state, payload) => {
      state.dismissed.push(payload);
      localStorage.setItem("dismissed", JSON.stringify(state.dismissed));
    },
    setQCMC: (state, payload) => {
      state.qcmc = payload;
    },
  },
});

export default store;
